module.exports = __webpack_public_path__ + "img/w3.c24b0d79.webp";